import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../Auth/_redux/authRedux";

const initialListingsState = {
  activeTab: 0,
};

export const configurationTabSlice = createSlice({
  name: "configurationTab",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    setConfigurationTabIndex: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setConfigurationTabIndex } = configurationTabSlice.actions;
